import React, { useEffect, useRef, useState } from "react";
import { COLLECTION, COLLECTION_COUNTER ,SESSION} from "../../../data/constant";
import {
  addDoc,
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  updateDoc,
  getCountFromServer,
  where, 
  Timestamp
} from "firebase/firestore";
import { db } from "../../../config/firebase";
import Layout from "./Layout";

const Dashboard = () => {

  const [userscount,setUserscount] = useState("")
  const [totaltransaction,setTotaltransaction] = useState("")
  const [todaytransaction,setTodaytransaction] = useState("")


  useEffect(() => {
    const countTodayAuth1Docs = async () => {
      const TransactionRef = collection(db, COLLECTION.PTRANSACTIONS); 
      const TransactionSnapshot = await getDocs(TransactionRef);
      const TransactionData = TransactionSnapshot.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
      }));
  
      const today = new Date().toISOString().split('T')[0];
  
      const convertFirestoreTimestamp = (timestamp) => {
        if (timestamp && typeof timestamp.seconds === "number") {
          return new Date(timestamp.seconds * 1000).toISOString().split('T')[0];
        }
        return null;
      };
  
      const auth1TodayCount = TransactionData.filter(obj => {
        if (!obj.transactionTime) return false; // 🚫 Skip if missing
        const transactionDate = convertFirestoreTimestamp(obj.transactionTime);
        return transactionDate === today && obj.auth === "Auth1";
      }).length;
  
      setTodaytransaction(auth1TodayCount);
    };
  
    countTodayAuth1Docs();
  }, []);
  
  

  useEffect(() => {
    const countAuth1Docs = async () => {
      const TransactionRef = collection(db, COLLECTION.PTRANSACTIONS);
      const TransactionSnapshot = await getDocs(TransactionRef);
      const TransactionData = TransactionSnapshot.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
      }));
  
      // Filter and count documents where auth === "Auth1"
      const auth1Count = TransactionData.filter(obj => obj.auth === "Auth1").length;
      setTotaltransaction(auth1Count)
  
    };
  
    countAuth1Docs();
  }, []);
  

  useEffect(() => {
    const userCount = async() =>{
      const collectionRef = collection(db,COLLECTION.PUSERS); 
      const snapshot = await getCountFromServer(collectionRef)
      const count = snapshot.data().count
      setUserscount(count)
    }
    userCount();
  }, []);

  return (
    <Layout 
    userscount={userscount}
    totaltransaction={totaltransaction}
    todaytransaction={todaytransaction}
    />
  );
};

export default Dashboard;
